import React, { Component, } from 'react'
import config from '../../resource/appConfig.js'

const addOnCountLimit = config.addOnLinkRecordsCountLimit

class addOnLink extends Component {
  constructor(props){
    super(props)
    this.handleClick = this.handleClick.bind(this)
  }

  handleClick(){
    let currentURL = window.location.href
    if(currentURL.includes("#main-content")){
        let originalURL = currentURL.replace("#main-content", "")
        let newURL = originalURL + "addOn"
        window.location.assign(newURL)
    }else{
        let newURL = currentURL + "addOn"
        window.location.assign(newURL)
    }
  }

  render() {
    let addOn = null
    if(this.props.PassDataItems.RECORDS_COUNT && this.props.PassDataItems.RECORDS_COUNT <= addOnCountLimit){
      addOn = <li><strong><p><button type="button" className="linkButton" onClick={this.handleClick} >Upload Add on File</button></p></strong></li>
    }
    return (
      <div>{addOn}</div>
    )
  }
}
export default addOnLink
